<template>
  <RsPartialNavigationContainer
    v-if="$rsGlobals.$userHasAtLeastOneAccess('connections') || $rsGlobals.$userHasAtLeastOneAccess('standard_listings')"
    :key="variant"
  >
    <RsPartialNavigationTree
      :title="$ts('listingManagement.nav.listingManagement')"
      icon="far fa-sync-alt rs-text-tertiary-medium-purple"
      active-icon="fas fa-sync-alt rs-text-primary"
      icon-size="lg"
      :variant="variant"
      :expanded="expanded"
      :active="routeStartsWith('/syndication')"
    >
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('standard_listings')"
        :title="$ts('listingManagement.nav.standardListings')"
        class="w-100 rs-text-white z-index-1"
        to="/syndication/standard-listings"
        :active="routeStartsWith('/syndication/standard-listings')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('promoted_listings')"
        :title="$ts('listingManagement.nav.promotedListings')"
        class="w-100 rs-text-white z-index-1"
        to="/syndication/promoted-listings"
        :active="routeStartsWith('/syndication/promoted-listings')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('connections')"
      >
        <RsPartialNavigationTree
          :title="$ts('listingManagement.nav.connections')"
          class="w-100 rs-text-white z-index-1"
          to="/syndication/connections"
          :active="routeStartsWith('/syndication/connections')"
          hide-expand-icon
        >
          <RsPartialNavigationTree
            v-if="routeParamExists('partnerId')"
            :key="`${routeParamExists('partnerId')}`"
            title="Partner Name"
            :title-fetcher="getPartnerTitleFetcher"
            class="w-100 rs-text-white z-index-1"
            :active="routeStartsWith('/syndication/connections') && routeParamExists('partnerId')"
            :expanded="routeStartsWith('/syndication/connections') && routeParamExists('partnerId')"
          >
            <RsPartialNavigationTreeBranch
              :title="$ts('listingManagement.nav.connectionDetails')"
              class="w-100 rs-text-white z-index-1"
              :to="`/syndication/connections/${$route.params.partnerId}/details`"
              :active="routeStartsWith('/syndication/connections') && routeParamExists('partnerId')"
            />
          </RsPartialNavigationTree>
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('standard_listings', 'update')"
        :title="$ts('listingManagement.nav.layouts')"
        class="w-100 rs-text-white z-index-1"
        to="/syndication/ad-layouts"
        :active="routeStartsWith('/syndication/ad-layouts')"
        :locked="$rsGlobals.$hasClientSettingValue('disable_ad_layouts', '1')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('standard_listings')"
        :title="$ts('listingManagement.nav.autoResponders')"
        class="w-100 rs-text-white z-index-1"
        to="/syndication/auto-responders"
        :active="routeStartsWith('/syndication/auto-responders')"
        :locked="$rsGlobals.$hasClientSettingValue('disable_auto_responders', '1')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('standard_listings')"
        :title="$ts('listingManagement.nav.integrations')"
        class="w-100 rs-text-white z-index-1"
        to="/syndication/outbound-integrations"
        :active="routeStartsWith('/syndication/outbound-integrations')"
        :locked="$rsGlobals.$hasClientSettingValue('disable_webhooks', '1')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('standard_listings', 'update')"
        :title="$ts('listingManagement.nav.listingSettings')"
        class="w-100 rs-text-white z-index-1"
        to="/syndication/settings/general"
        :active="routeStartsWith('/syndication/settings')"
      />
    </RsPartialNavigationTree>
  </RsPartialNavigationContainer>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import {
  routeStartsWith,
  routeParamExists,
} from '@/shared/helpers/navigation-active-helpers';
import RsPartialNavigationContainer from '@/components/RsPartialNavigationContainer.vue';
import RsPartialNavigationTree, { NavigationTreeVariantType } from '@/components/RsPartialNavigationTree.vue';
import RsPartialNavigationTreeBranch from '@/components/RsPartialNavigationTreeBranch.vue';
import partners from '@/shared/services/partners';
import { decodeHtml } from '@/shared';

export default defineComponent({
  name: 'RsPartialNavProperties',
  components: {
    RsPartialNavigationContainer,
    RsPartialNavigationTree,
    RsPartialNavigationTreeBranch,
  },
  props: {
    variant: {
      type: String as PropType<NavigationTreeVariantType>,
      default: 'collapse',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    routeStartsWith,
    routeParamExists,
    async getPartnerTitleFetcher(): Promise<string> {
      if (this.$route.params.partnerId) {
        const partner = (await partners.getPartnerById(this.$route.params.partnerId as string)).data;
        return decodeHtml(partner?.name || '');
      }
      return '';
    },
  },
});

</script>
